/**
 * Like callWhenIdle from @jira/platform__utils-call-when-idle, but modified to add a timeout due to
 * suspected render loops meaning requestIdleCallback never runs.
 */
export const callWhenIdleWithTimeout = (
	callback: (deadline?: IdleDeadline) => void,
): (() => void) => {
	if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
		const callbackId = window.requestIdleCallback(
			callback,
			// In case there's a render loop on the page starving out idle callbacks
			{ timeout: 5_000 },
		);
		return () => cancelIdleCallback(callbackId);
	}
	// Browsers without requestIdleCallback
	const timer = setTimeout(callback, 2_000);
	return () => {
		clearTimeout(timer);
	};
};
